import CodeConfirm from "./code-confirm";

export default CodeConfirm